import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { apiClient } from '@/src/utils/api-client';

export function useApiClient() {
  const { data: session, status } = useSession();

  useEffect(() => {
    // Handle different session states
    if (status === 'loading') {
      return; // Don't change token while loading
    }
    
    if (status === 'authenticated' && session?.accessToken) {
      apiClient.setAccessToken(session.accessToken);
    } else if (status === 'unauthenticated') {
      // Explicitly clear token on logout/unauthenticated
      apiClient.setAccessToken(null);
    }
  }, [session?.accessToken, status]);

  return apiClient;
}
